import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.review');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-review',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.review/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.review-shell {
  min-height: 100vh;
  color: #20233a;
  background: #f6f6f9;
}

.review-header {
  position: sticky;
  z-index: 30;
  top: 0;
  height: 72px;
  display: flex;
  align-items: center;
  padding: 0 clamp(22px, 4vw, 58px);
  border-bottom: 1px solid #e4e4eb;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(10px);
}

.review-brand {
  min-width: 240px;
  display: flex;
  align-items: center;
  color: #22253c;
  gap: 11px;
}

.brand-mark {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  border-radius: 12px;
  color: white;
  background: #353c71;
  font-size: 17px;
  font-weight: 850;
}

.review-brand strong,
.review-brand small {
  display: block;
}

.review-brand strong {
  font-size: 13px;
}

.review-brand small {
  margin-top: 3px;
  color: #8b8da0;
  font-size: 9px;
}

.review-nav {
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: clamp(16px, 5vw, 80px);
  gap: 4px;
}

.review-nav a,
.review-nav button {
  height: 100%;
  display: inline-flex;
  align-items: center;
  padding: 0 16px;
  border: 0;
  border-bottom: 2px solid transparent;
  color: #6f7183;
  background: transparent;
  font-family: inherit;
  font-size: 11px;
  font-weight: 650;
  gap: 6px;
}

.review-nav a.is-active {
  border-bottom-color: #454d8c;
  color: #353c71;
}

.review-nav button:disabled {
  cursor: default;
  opacity: 0.58;
}

.review-nav em {
  padding: 2px 4px;
  border-radius: 4px;
  background: #f0f0f5;
  font-size: 7px;
  font-style: normal;
}

.review-user {
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: 10px;
}

.review-user div {
  text-align: right;
}

.review-user strong,
.review-user small {
  display: block;
}

.review-user strong {
  color: #323448;
  font-size: 10px;
}

.review-user small {
  margin-top: 2px;
  color: #999bac;
  font-size: 8px;
}

.review-user > span {
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  border-radius: 50%;
  color: #454d8c;
  background: #ececf5;
  font-size: 11px;
  font-weight: 800;
}

.review-user > a {
  color: #85879a;
  font-size: 15px;
}

.review-user .logout-button {
  padding: 5px 7px;
  border: 1px solid #dedfe8;
  border-radius: 7px;
  color: #686a7b;
  background: #fff;
  font-size: 8px;
  font-weight: 700;
}

.review-context {
  min-height: 62px;
  display: flex;
  align-items: center;
  padding: 10px clamp(22px, 4vw, 58px);
  color: #dfe3ff;
  background: #353c71;
}

.review-context > div:first-child {
  display: flex;
  align-items: center;
  gap: 16px;
}

.context-label {
  color: #aeb5e3;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.14em;
}

.review-context strong {
  font-size: 11px;
  font-weight: 650;
}

.review-context select {
  max-width: 220px;
  height: 30px;
  border: 1px solid rgba(222, 227, 255, 0.28);
  border-radius: 7px;
  padding: 0 27px 0 9px;
  color: #fff;
  background: #41497f;
  font-size: 9px;
  font-weight: 700;
}

.review-context select:disabled {
  opacity: 0.85;
}

.context-policy {
  display: flex;
  margin-left: auto;
  gap: 16px;
}

.context-policy span {
  display: inline-flex;
  align-items: center;
  color: #bfc4e7;
  font-size: 9px;
  gap: 6px;
}

.context-policy i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #73d4af;
}

.review-main {
  min-height: calc(100vh - 134px);
}

.app-loading {
  position: fixed;
  z-index: 100;
  inset: 0;
  display: grid;
  place-items: center;
  background: rgba(25, 27, 53, 0.2);
  backdrop-filter: blur(4px);
}

.loading-spinner {
  width: 44px;
  height: 44px;
  color: #454d8c;
}

@media (max-width: 850px) {
  .review-header {
    height: auto;
    min-height: 68px;
    flex-wrap: wrap;
    padding: 14px 20px 0;
  }
  .review-brand {
    min-width: 0;
  }
  .review-nav {
    width: 100%;
    height: 42px;
    order: 3;
    margin: 8px 0 0;
    overflow-x: auto;
  }
  .review-nav a,
  .review-nav button {
    height: 42px;
    padding: 0 12px;
    white-space: nowrap;
  }
  .review-user div {
    display: none;
  }
  .review-context {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }
  .context-policy {
    width: 100%;
    margin-left: 0;
    overflow-x: auto;
  }
}
@media (max-width: 520px) {
  .review-brand small,
  .context-label {
    display: none;
  }
  .review-context > div:first-child {
    flex-wrap: wrap;
    gap: 7px;
  }
  .context-policy span {
    white-space: nowrap;
  }
}`],
})
export class LayoutReviewComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.check()) {
            location.href = '/access';
            return;
        }
        let session = this.service.auth.session || {};
        if (session.account_status !== 'ACTIVE') {
            location.href = '/status/pending';
            return;
        }
        if ((session.portals || []).indexOf('review') < 0) {
            location.href = '/forbidden';
            return;
        }
        if (!this.currentDatasetHasReviewRole() && this.reviewDatasets().length) {
            await this.selectDataset(this.reviewDatasets()[0].dataset_id);
        }
    }

    public isActive(path: string) {
        return location.pathname.indexOf(path) === 0;
    }

    public currentDatasetName() {
        let dataset = this.service.auth.session.current_dataset || {};
        return dataset.dataset_name || '검수 데이터셋';
    }

    public currentDatasetId() {
        let dataset = this.service.auth.session.current_dataset || {};
        return dataset.dataset_id || '';
    }

    public currentDatasetHasReviewRole() {
        let dataset = this.service.auth.session.current_dataset || {};
        let roles = dataset.roles || [];
        return roles.indexOf('REVIEWER') >= 0 || roles.indexOf('REVIEW_ADMIN') >= 0;
    }

    public reviewDatasets() {
        let datasets = this.service.auth.session.dataset_roles || [];
        return datasets.filter((dataset: any) => {
            let roles = dataset.roles || [];
            return roles.indexOf('REVIEWER') >= 0 || roles.indexOf('REVIEW_ADMIN') >= 0;
        });
    }

    public async selectDataset(datasetId: string) {
        if (!datasetId || datasetId === this.currentDatasetId()) return;
        let result: any = await this.service.request.post('/api/datasets/select', {
            dataset_id: datasetId
        });
        if (result.code !== 200) {
            await this.service.modal.show({
                title: '검수 데이터셋 선택 실패',
                message: result.data && result.data.message ? result.data.message : '검수 데이터셋을 선택하지 못했습니다.',
                cancel: false,
                action: '확인',
                actionBtn: 'error',
                status: 'error'
            });
            return;
        }
        location.reload();
    }

    public userInitial() {
        let name = this.service.auth.session.name || '검수자';
        return name.substring(0, 1);
    }

    public async logout() {
        await this.service.request.post('/api/account/logout');
        location.href = '/access';
    }
}

export default LayoutReviewComponent;